export default "__VITE_ASSET__BRn0pR5t__"